import React from 'react';

const InvisibleIcon = (props: any) => {
  return (
    <svg height="16" width="16" fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.5644 11.5641C10.5387 12.3459 9.28985 12.779 8.00039 12.8001C3.80039 12.8001 1.40039 8.00009 1.40039 8.00009C2.14672 6.60923 3.18187 5.39405 4.43639 4.43609M6.74039 3.34409C7.15339 3.24742 7.57623 3.19909 8.00039 3.20009C12.2004 3.20009 14.6004 8.00009 14.6004 8.00009C14.2362 8.68145 13.8018 9.32293 13.3044 9.91409M9.27239 9.27209C9.1076 9.44894 8.90888 9.59078 8.68808 9.68916C8.46728 9.78754 8.22893 9.84044 7.98724 9.84471C7.74556 9.84897 7.50549 9.80451 7.28136 9.71398C7.05722 9.62345 6.85362 9.4887 6.6827 9.31778C6.51177 9.14685 6.37703 8.94325 6.2865 8.71912C6.19597 8.49499 6.15151 8.25492 6.15577 8.01323C6.16003 7.77155 6.21294 7.5332 6.31132 7.3124C6.4097 7.0916 6.55154 6.89288 6.72839 6.72809"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
      />
      <path d="M1.40039 1.40002L14.6004 14.6" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" />
    </svg>
  );
};

export default InvisibleIcon;
